import Cookie from 'js-cookie';
import { getCompanyInfo } from '@src/services/userInfo';
import { getUserInfo } from '@src/services/accountSettings';
import { cryptoDecrypt } from '@src/utils/encryption';

/** 因有些接口需要依赖公司名称，恰好初始公司名称还没有请求到的情况
 * @param {Object} - companyInfo 从context中取出的公司信息
 */
export const pendingCompanyInfo = async (companyInfo) => {
  if (companyInfo.companyName) {
    return companyInfo;
  }

  const res = await getCompanyInfo();

  return res;
};


/** 因有些接口需要依赖用户信息，恰好初始用户信息还没有请求到的情况
 * @param {Object} - userInfo 从context中取出的用户信息
 */
export const pendingUserInfo = async (userInfo) => {
  if (userInfo.accountId || userInfo.accountId === 0) {
    return userInfo;
  }

  const res = await getUserInfo(cryptoDecrypt(Cookie.get('uID') || ''));

  return res;
};


// 登录过期清空Cookie
export const resetCookie = () => {
  // Cookie.remove('TOKEN');
  Cookie.remove('fromMainPage');
  Cookie.remove('fromSubPage');
  Cookie.remove('fromMainPagePS');
  Cookie.remove('fromSubPagePS');
  Cookie.remove('fromUrlPS');
  Cookie.remove("fromMainPageTemp");
  Cookie.remove("fromSubPageTemp");
  Cookie.remove("fromUrlTemp");
  Cookie.remove('selected_region');
  Cookie.remove('selected_cpe_id');
  Cookie.remove('selected_project_custportal');
  Cookie.remove('uID');
  Cookie.remove('fromTo');
  Cookie.remove('next-i18next');
  Cookie.remove('fromtimeZone');
  Cookie.remove('_csrf');
  Cookie.remove('connect.sid');
  Cookie.remove('io');
  Cookie.remove('XSRF-TOKEN');
  Cookie.remove('fromcsrftoken');
  Cookie.remove('userLoginLocale');
  localStorage.removeItem('permissions')
};
